import type { FC } from 'react';

import { InputText, RadioGroup, RadioButton, InputNumber, TextArea } from '@eneco/sparky';
import { Control, Controller, FieldErrors, UseFormRegister } from 'react-hook-form';

import { hintOf } from './hint';
import type { FormValues } from './types';
import type { HeatDamageFormFields } from '../heat-damage-form-content.types';

type Props = {
  register: UseFormRegister<FormValues>;
  formFields: HeatDamageFormFields;
  control: Control<FormValues, string>;
  errors: FieldErrors<FormValues>;
};

export const DamageInputs: FC<Props> = ({ register, formFields, errors, control }) => {
  const { isHomeOwnerFormField, descriptionFormField, insurerFormField, estimatedDamageFormField } = formFields;

  return (
    <>
      <Controller
        control={control}
        name="isHomeOwner"
        render={({ field: { onChange, value, name } }) => (
          <RadioGroup
            name={name}
            value={value?.toString()}
            onValueChange={onChange}
            label={isHomeOwnerFormField?.label ?? ''}
            error={errors?.isHomeOwner?.message}
            hint={hintOf(isHomeOwnerFormField?.hint)}>
            <RadioButton value={'true'}>
              {isHomeOwnerFormField?.options?.find(option => option.name === 'owner')?.label ?? `owner`}
            </RadioButton>
            <RadioButton value={'false'}>
              {isHomeOwnerFormField?.options?.find(option => option.name === 'tenant')?.label ?? `tenant`}
            </RadioButton>
          </RadioGroup>
        )}
      />
      <TextArea
        label={descriptionFormField.label ?? ''}
        error={errors?.description?.message}
        hint={hintOf(descriptionFormField.hint)}
        placeholder={descriptionFormField?.placeholder ?? ''}
        rows={5}
        {...register('description')}
      />
      <InputText
        label={insurerFormField?.label ?? ''}
        error={errors?.insurer?.message}
        hint={hintOf(insurerFormField?.hint)}
        placeholder={insurerFormField?.placeholder ?? ''}
        {...register('insurer')}
        isOptional
      />
      <InputNumber
        label={estimatedDamageFormField?.label ?? ''}
        error={errors?.estimatedDamage?.message}
        hint={hintOf(estimatedDamageFormField?.hint)}
        placeholder={estimatedDamageFormField?.placeholder ?? ''}
        {...register('estimatedDamage')}
        formatOptions={{
          currency: 'EUR',
          minimumFractionDigits: 2,
        }}
        isOptional
      />
    </>
  );
};
